export const SLIDESHOW_DEFAULTS = {
    aspectRatio: '16:9',
    startTransition: 'fade',
    startTransitionDuration: 1000,
    slide: {
        duration: 3000,
        transition: 'fade',
        transitionDuration: 1000,
        backgroundColor: '#000000'
    },
    item: {
        rotation: 0,
        positionX: 0,
        positionY: 0,
        width: 100,
        height: 100
    }
} as const;
